<template>
  <div class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-snackbar
            v-model="dialog.snackbar"
            top
            right
            color="#ff64ad">
            <span class="body-1 font-weight-light white--text"
              v-html="message.success">
            </span>

            <template v-slot:action="{ attrs }">
              <v-btn
                class="body-1 font-weight-bold text-capitalize"
                color="white"
                icon
                v-bind="attrs"
                @click="dialog.snackbar = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>

          <v-row>
            <v-col cols="12" md="7">
              <v-card flat>
                <v-card-text class="pa-0">
                  <div @click="$router.go(-1)"
                    class="d-flex align-center color-first cursor-pointer mb-4">
                    <v-icon color="#ff64ad">mdi-arrow-left-thick</v-icon>
                
                    <span class="body-1 ml-1">
                      Kembali
                    </span>
                  </div>

                  <ValidationObserver ref="form">
                    <v-form class="text-left">
                      <ValidationProvider 
                        name="title" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Judul
                          <span class="error--text">
                            (wajib diisi)
                          </span>
                        </div>
                        
                        <v-text-field
                          class="mb-6"
                          :style="`width: ${rps === 'xs' ? 100 : 70}%`"
                          v-on:keyup.enter="save"
                          outlined
                          dense
                          color="#ff64ad"
                          placeholder="Contoh. Bencana Alam di Kabupaten Klaten"
                          hide-details
                          v-model="form.title"
                          v-uppercase
                          :success="valid"
                          :error-messages="errors"
                          required>
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                Judul {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.title !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>

                      <ValidationProvider 
                        name="category" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Kategori
                          <span class="error--text">
                            (wajib diisi)
                          </span>
                        </div>
                        
                        <v-autocomplete
                          class="mb-6"
                          :style="`width: ${rps === 'xs' ? 100 : 40}%`"
                          outlined
                          dense
                          color="#ff64ad"
                          placeholder="Contoh. Bencana"

                          :search-input.sync="autocomplete.category"
                          :loading="process.category"
                          
                          :items="config.category"
                          item-value="cat_id"
                          item-text="cat_title"
                          item-color="#ff64ad"

                          hide-details

                          v-model="form.cat_id"
                          :success="valid"
                          :error-messages="errors"
                          required>

                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                Kategori {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.cat_id !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>

                          <template v-slot:selection="{ item }">
                            <v-avatar size="30">
                              <v-img 
                                alt="kominfo" 
                                :src="item.cat_image"
                                class="ma-auto">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      indeterminate 
                                      color="#ff64ad">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-avatar>

                            <span class="ml-2">
                              {{ item.cat_title }}
                            </span>
                          </template>
                          
                          <template v-slot:item="{ item }">
                            <v-avatar size="30">
                              <v-img 
                                alt="kominfo" 
                                :src="item.cat_image"
                                class="ma-auto">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      indeterminate 
                                      color="#ff64ad">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-avatar>

                            <span class="ml-2">
                              {{ item.cat_title }}
                            </span>
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>

                      <div class="mb-6">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Keterangan
                          <span class="error--text">
                            (wajib diisi)
                          </span>
                        </div>

                        <quill-editor 
                          ref="myTextEditor"
                          :options="{
                            placeholder: 'Contoh. Tanggul sungai dengkeng jebol, kontruksi tidak bagus'
                          }"
                          v-model="form.content">
                        </quill-editor>
                      </div>

                      <div>
                        <div class="body-2 mb-2">
                          Status
                          <span>
                            (boleh dikosongi)
                          </span>
                        </div>

                        <v-select
                          :style="`width: ${rps === 'xs' ? 100 : 30}%`"
                          dense
                          outlined
                          single-line
                          color="#ff64ad"
                          item-color="pink darken-1"
                          placeholder="Contoh: publish"
                          :items="['publish', 'draft']"
                          v-model="form.status"
                          :success="form.status !== ''">
                          <template slot="selection" slot-scope="data">
                            <span class="text-capitalize">
                              {{ data.item }}
                            </span>
                          </template>

                          <template slot="item" slot-scope="data">
                            <span class="text-capitalize">
                              {{ data.item }}
                            </span>
                          </template>
                          
                          <template v-slot:append-outer>
                            <div v-if="form.status !== ''">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-select>
                      </div>
                    </v-form>
                  </ValidationObserver>
                  
                  <v-alert 
                    type="error" 
                    text dense prominent 
                    class="mt-6"
                    v-show="message.error.length > 0">
                    {{  message.error }}
                  </v-alert>
                </v-card-text>

                <div>
                  <v-divider class="mb-4" style="border: 3px solid #eaeaea; border-radius: 50px;"/>

                  <v-card-actions>
                    <v-spacer/>

                    <v-btn
                      color="#ff64ad"
                      elevation="0"
                      class="body-2 font-weight-bold text-capitalize white--text"
                      :disabled="process.form"
                      :loading="process.form"
                      v-on:keyup.enter="save()"
                      @click="save()">
                      <v-icon small class="mr-1">mdi-check-bold</v-icon>
                      Simpan
                    </v-btn>

                    <v-btn
                      outlined
                      class="body-2 font-weight-bold text-capitalize red--text"
                      :disabled="process.form"
                      @click="$router.go(-1)">
                      <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
                      Batal
                    </v-btn>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" md="5">
              <div :class="scroll ? 'on-scroll-sticky' : 'on-scroll-ralative'" v-scroll="onScroll">
                <v-card
                  class="border-radius"
                  style="box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 12px;">
                  <v-card-text>
                    <div>
                      <div class="body-1 font-weight-bold black--text">
                        Gambar Kover
                      </div>

                      <v-divider class="mt-2 mb-4" style="border: 3px solid #eaeaea; border-radius: 50px;" />
                    </div>

                    <v-row>
                      <v-col 
                        v-for="(item, index) in form.image"
                        :key="index"
                        cols="6" md="4">
                        <v-card 
                          flat
                          height="150"
                          class="d-flex align-center justify-center"
                          style="border-radius: 15px;
                                border: 2px solid #eaeaea; 
                                border-style: dashed;
                                box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; ">
                          <v-img 
                            alt="kominfo" 
                            width="100%"
                            height="150"
                            :src="item.url"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  indeterminate 
                                  color="#ff64ad">
                                </v-progress-circular>
                              </v-row>
                            </template>

                            <div @click="form.image.splice(index, 1)"
                              class="cursor-pointer"
                              style="position: absolute; top: 5px; right: 5px;">
                              <v-icon size="20" color="red">mdi-close-circle</v-icon>
                            </div>
                          </v-img>
                        </v-card>
                      </v-col>

                      <v-col cols="6" md="4">
                        <uploadfolder v-model="upload.folder">
                          <div slot="activator" class="cursor-pointer">
                            <v-card 
                              flat
                              height="150"
                              class="d-flex align-center justify-center"
                              style="border-radius: 15px;
                                    border: 2px solid #eaeaea; 
                                    border-style: dashed;">
                              <v-icon v-if="!process.image"
                                size="60" 
                                color="grey">
                                mdi-cloud-upload-outline
                              </v-icon>

                              <v-progress-circular v-else
                                indeterminate
                                color="#ff64ad">
                              </v-progress-circular>
                            </v-card>
                          </div>
                        </uploadfolder>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        scroll: false,
        dialog: {
          snackbar: false
        },
        upload: {
          folder: null
        },
        autocomplete: {
          category: ''
        },
        config: {
          category: []
        },
        form: {
          id: '',
          title: '',
          cat_id: '',
          cat_title: '',
          status: '',
          type: 'news',
          content: '',
          image: [],
          extra: {
            createdby: {
              name: '',
              email: ''
            }
          }
        },
        process: {
          form: false,
          category: false,
          image: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.image = this.upload.folder.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              this.form.image.push({
                url: this.upload.folder.data.full.file_url,
                type: this.upload.folder.type,
                process: this.upload.folder.process,
                user_id: this.user.id,
                file_id: this.upload.folder.id === undefined ? 0 : this.upload.folder.id
              })
            }
          }
        },
        deep: true
      },
      'form.cat_id': function() {
        let t = this
        let cat = this.config.category.filter(function(v) {
          return t.form.cat_id == v.cat_id
        })

        if (cat.length > 0) {
          this.form.cat_title = cat[0].cat_title
        }
      },
      'autocomplete.category': function() {
        this.static().category()
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps() {
        return this.$vuetify.breakpoint.name
      }
    },
    mounted () {
      this.fetchData()
    },
    methods: {
      onScroll(e) {
        if (typeof window === 'undefined') return
        const top = window.pageYOffset || e.target.scrollTop || 0
        this.scroll = top > window.innerHeight - 1000
      },
      async fetchData () {
        let params = {
          id: this.$route.params.id
        }

        await get(`post/detail`, { params })
        .then(response => {
          let res = response.data

          if (res.code == 200) {
            let item = res.data

            this.form = {
              id: item.post_id,
              title: item.post_title,
              cat_id: item.post_cat_id,
              cat_title: item.post_cat_title,
              status: item.post_status,
              type: item.post_type,
              content: item.post_content,
              image: item.post_image,
              extra: item.post_extra
            }
          }
        })
      },
      static () {
        let t = this
        return {
          async category () {
            t.process.category = true

            let params = {
              sort: 'cat_pos',
              order_by: 'ASC',
              cat_type: 'news',
              search: t.autocomplete.category
            }

            await get(`category`, { params })
            .then(response => {
              let res = response.data

              if (res.code == 200) {
                t.process.category = false

                t.config.category = res.data
              }
            })
          }
        }
      },
      async save() {
        this.message.error = ''

        this.form.extra.createdby = {
          name: this.user.fullname,
          email: this.user.email,
          image: this.user.image
        }
        
        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`post/update`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            if (res.code === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message

              this.$router.push('/news')
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>